/**
 * Created by Alex Aguilar on 8/22/2016.
 */
(function() {
    'use strict';

    angular
        .module('completeAir')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
